<template>
  <footer
    id="new-footer"
    padless
    app
    class="d-flex justify-center"
  >
    <v-container fluid>
      <v-row class="px-3 px-md-12 mt-10 mb-6">
        <v-col class="d-flex">
          <a 
            :href="$store.getters.getCompany.url" 
            target="_blank" 
            rel="noopener noreferrer"
            class=""
          >
            <v-img
              max-height="250"
              max-width="250"
              src="@/assets/logoCMF.png"
            ></v-img>
          </a>
        </v-col>
      </v-row>
      <v-row class="footer-text px-md-12 mb-10 justify-center">
        <v-col cols="12" md="7" class="pr-12 px-6">
          <p
            v-for="(parag, i) in $store.getters.getCompany.paragraphs"
            :key="i"
            class="body-2"
          >
            {{ parag }}
          </p>
          <p class="body-2">
            Para mais informações, por favor, acesse 
            <a 
              :href="$store.getters.getCompany.url" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              {{ $store.getters.getCompany.website }}
            </a> 
          </p>
        </v-col>
        <v-col cols="12" md="5" class="social py-10 py-md-0 d-flex justify-center">
          <div class="text-center">
            <p class="allcaps">Acompanhe nossas mídias sociais</p>
            <div class="mt-8">
              <v-btn
                v-for="(icon, k) in $store.getters.getCompany.social"
                :key="k"
                :href="icon.href"
                target="_blank"
                class="mx-2 social-btn"
                icon
                fab
              >
                <v-icon size="30px">
                  {{ icon.i }}
                </v-icon>
              </v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
      <v-row class="copy-text px-md-12 d-flex justify-center justify-md-space-between">
        <div cols="12" class="d-flex justify-center justify-md-start text-center text-md-left">
          <span class="caption">
            Copyright &copy; {{ new Date().getFullYear() }} {{ $store.getters.getCompany.footerTxt }}. Todos os direitos reservados.
          </span>
        </div>
        <div cols="12" class="d-flex justify-center justify-self-md-end mt-8 mt-md-0">
          <a 
            href="https://www.we4u.com.br" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            <img
              height="25px"
              src="@/assets/logo-we4u.png"
            />
          </a>
        </div>
      </v-row>
    </v-container>
  </footer>
</template>

<script>
export default {
  data () {
    return {
      // copyTxt: 'Webinars For You, Ltd',
      // socialIcons: [
      //   {
      //     i: 'mdi-facebook',
      //     href: '',
      //     name: 'facebook'
      //   },
      //   {
      //     i: 'mdi-instagram',
      //     href: '',
      //     name: 'instagram'
      //   },
      //   {
      //     i: 'mdi-linkedin',
      //     href: '',
      //     name: 'linkedin'
      //   },
      // ],
    }
  },
  methods: {
    registerClick(name) {
      // console.log()
      this.$store.dispatch("registerEvent", { 
        id: 'footer-social-' + name,
        url: this.$router.currentRoute.path
      })
    },
    registerClick2(name) {
      this.$store.dispatch("registerEvent", { 
        id: name,
        url: this.$router.currentRoute.path
      })
    }
  },
}
</script>

<style lang="scss">
#new-footer{
  // z-index: 999
}
</style>